import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree} from '@angular/router';
import {Observable} from 'rxjs';
import {DataService} from '../../shared/services/data.service';

@Injectable({
  providedIn: 'root'
})
export class IsPageEnabledGuard implements CanActivate {

  constructor(private router: Router) {
  }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

    const found = DataService.HEADER_MENU_ITEMS.find(item => next.routeConfig.path.includes(item.state));

    if (found) {
      return true;
    }

    this.router.navigate(['']);
    return false;
  }

}
